(function () {
  'use strict';

  if (window.mtNavInitialized) return;
  window.mtNavInitialized = true;

  function getSavedTheme() {
    try {
      return localStorage.getItem('mt-theme') || 'light';
    } catch (e) {
      return 'light';
    }
  }

  function applyTheme(theme) {
    if (!document.body) return;

    document.body.classList.remove('mt-theme-dark', 'mt-theme-light');
    document.body.classList.add('mt-theme-' + theme);

    try {
      localStorage.setItem('mt-theme', theme);
    } catch (e) {}

    document.querySelectorAll('.mt-theme-logo').forEach(function (img) {
      if (!img.dataset.lightSrc || !img.dataset.darkSrc) return;
      img.src = theme === 'dark' ? img.dataset.darkSrc : img.dataset.lightSrc;
    });

    document.querySelectorAll('.mt-theme-transition-img').forEach(function (img) {
      if (!img.dataset.lightSrc || !img.dataset.darkSrc) return;
      img.src = theme === 'dark' ? img.dataset.darkSrc : img.dataset.lightSrc;
    });
  }

  function setArrowText(element, isOpen) {
    if (!element) return;

    if (isOpen) {
      element.textContent = element.textContent.replace('▾', '▴');
    } else {
      element.textContent = element.textContent.replace('▴', '▾');
    }
  }

  function closeMobileMenu(mobileToggle, mobileMenu) {
    if (!mobileToggle || !mobileMenu) return;

    mobileMenu.style.display = 'none';
    mobileToggle.dataset.mtMobileOpen = 'false';

    var menuIcon = mobileToggle.querySelector('.icon-menu');
    var closeIcon = mobileToggle.querySelector('.icon-close');

    if (menuIcon) menuIcon.style.display = 'block';
    if (closeIcon) closeIcon.style.display = 'none';
  }

  function initMtNav() {
    var nav = document.getElementById('mt-nav');
    var themeToggle = document.getElementById('mt-theme-toggle');
    var mobileToggle = document.getElementById('mt-mobile-toggle');
    var mobileMenu = document.getElementById('mt-mobile-menu');

    applyTheme(getSavedTheme());

    if (themeToggle) {
      themeToggle.addEventListener('click', function () {
        var current = document.body.classList.contains('mt-theme-dark') ? 'dark' : 'light';
        applyTheme(current === 'light' ? 'dark' : 'light');
      });
    }

    if (nav) {
      window.addEventListener(
        'scroll',
        function () {
          nav.classList.toggle('is-scrolled', window.scrollY > 60);
        },
        { passive: true }
      );
    }

    var megaTimeout = null;

    function openMega(key) {
      clearTimeout(megaTimeout);

      document.querySelectorAll('.mt-mega').forEach(function (mega) {
        mega.style.display = 'none';
      });

      var targetMega = document.getElementById('mt-mega-' + key);

      if (targetMega) {
        targetMega.style.display = 'block';
      }
    }

    function closeMega() {
      megaTimeout = setTimeout(function () {
        document.querySelectorAll('.mt-mega').forEach(function (mega) {
          mega.style.display = 'none';
        });

        document.querySelectorAll('.mt-nav__item').forEach(function (item) {
          item.classList.remove('is-active');
        });
      }, 180);
    }

    document.querySelectorAll('.mt-nav__item[data-mega]').forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        document.querySelectorAll('.mt-nav__item').forEach(function (navItem) {
          navItem.classList.remove('is-active');
        });

        item.classList.add('is-active');
        openMega(item.dataset.mega);
      });

      item.addEventListener('mouseleave', closeMega);
    });

    document.querySelectorAll('.mt-mega').forEach(function (mega) {
      mega.addEventListener('mouseenter', function () {
        clearTimeout(megaTimeout);
      });

      mega.addEventListener('mouseleave', closeMega);
    });

    if (mobileToggle && mobileMenu) {
      mobileToggle.setAttribute('type', 'button');
      mobileToggle.dataset.mtMobileOpen = 'false';

      mobileToggle.addEventListener('click', function (event) {
        event.preventDefault();

        var isOpen = mobileToggle.dataset.mtMobileOpen === 'true';

        mobileToggle.dataset.mtMobileOpen = isOpen ? 'false' : 'true';
        mobileMenu.style.display = isOpen ? 'none' : 'block';

        var menuIcon = mobileToggle.querySelector('.icon-menu');
        var closeIcon = mobileToggle.querySelector('.icon-close');

        if (menuIcon) menuIcon.style.display = isOpen ? 'block' : 'none';
        if (closeIcon) closeIcon.style.display = isOpen ? 'none' : 'block';

        document.querySelectorAll('.mt-mega').forEach(function (mega) {
          mega.style.display = 'none';
        });
      });

      mobileMenu.addEventListener(
        'click',
        function (event) {
          var topToggle = event.target.closest('.mt-mobile-menu__toggle');

          if (topToggle && mobileMenu.contains(topToggle)) {
            event.preventDefault();
            event.stopPropagation();

            var subMenu = topToggle.nextElementSibling;

            if (!subMenu || !subMenu.classList.contains('mt-mobile-menu__sub')) return;

            var isSubOpen = subMenu.style.display === 'flex' || subMenu.style.display === 'block';

            subMenu.style.display = isSubOpen ? 'none' : 'flex';
            setArrowText(topToggle, !isSubOpen);

            return;
          }

          var mainToggle = event.target.closest('.mt-mobile-menu__main-toggle');

          if (mainToggle && mobileMenu.contains(mainToggle)) {
            event.preventDefault();
            event.stopPropagation();

            var content = mainToggle.nextElementSibling;

            if (!content || !content.classList.contains('mt-mobile-menu__main-content')) return;

            var isContentOpen = content.classList.contains('is-open');

            content.classList.toggle('is-open', !isContentOpen);
            content.style.display = isContentOpen ? 'none' : 'block';
            setArrowText(mainToggle, !isContentOpen);
          }
        },
        true
      );

      mobileMenu.querySelectorAll('a.mt-mobile-menu__item, a.mt-mobile-menu__subitem').forEach(function (link) {
        link.addEventListener('click', function () {
          closeMobileMenu(mobileToggle, mobileMenu);
        });
      });
    }

    updateCartBadge();
  }

  function updateCartBadge() {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var cartIcon = document.querySelector('.mt-nav__icon[aria-label="Cart"]');

        if (!cartIcon) return;

        var badge = cartIcon.querySelector('.mt-cart-badge');

        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'mt-cart-badge';
          cartIcon.appendChild(badge);
        }

        var count = cart.item_count;

        if (count > 0) {
          badge.textContent = count > 99 ? '99+' : count;
          badge.classList.add('is-visible');
          badge.classList.remove('pop');
          void badge.offsetWidth;
          badge.classList.add('pop');
        } else {
          badge.classList.remove('is-visible');
        }
      })
      .catch(function () {});
  }

  if (!window.mtFetchCartBadgePatched) {
    window.mtFetchCartBadgePatched = true;

    var originalFetch = window.fetch;

    window.fetch = function () {
      var result = originalFetch.apply(this, arguments);
      var url = arguments[0] && arguments[0].toString ? arguments[0].toString() : '';

      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
        result.then(function () {
          setTimeout(updateCartBadge, 300);
        });
      }

      return result;
    };
  }

  document.addEventListener('cart:updated', updateCartBadge);
  document.addEventListener('cart:change', updateCartBadge);

  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest('cart-items')) {
      setTimeout(updateCartBadge, 300);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMtNav);
  } else {
    initMtNav();
  }
})();